import { useMemo } from 'react'
import { Grid, Typography } from '@mui/material'
import { GridColDef, GridRowParams } from '@mui/x-data-grid-pro'

import SimpleTable from '../../../components/simple-table'
import { getFormattedDateTime } from '../../../utils/helpers'
import useStyles from '../index.styles'

import AlertTablePanelNotifyPreferences from './alert-table-column-renderers/alerts-table-panel-notify-preferences'
import AlertTablePanelPerson from './alert-table-column-renderers/alerts-table-panel-person'
import AlertTablePanelResponse from './alert-table-column-renderers/alerts-table-panel-response'

const columns = [
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    width: 400,
    sortable: false,
  },
  {
    field: 'channel',
    headerName: 'Channel',
    flex: 1,
    sortable: false,
  },
  {
    field: 'response',
    headerName: 'Response',
    flex: 1,
    sortable: false,
    renderCell: AlertTablePanelResponse,
  },
  {
    field: 'person',
    headerName: 'Person',
    flex: 1,
    sortable: false,
    renderCell: AlertTablePanelPerson,
  },
  {
    field: 'preferences',
    headerName: 'Preferences',
    flex: 1,
    sortable: false,
    renderCell: AlertTablePanelNotifyPreferences,
  },
] satisfies GridColDef[]

const AlertsTablePanelContent = ({ row }: GridRowParams<DeviceAlertTableRow>) => {
  const classes = useStyles
  const rows = useMemo(
    () =>
      row.alert.responses
        .map((response, idx) => ({
          id: idx,
          timestamp: getFormattedDateTime(response.updatedAt),
          channel: response.reactionType,
          response: response.note,
          person: response.user,
          preferences: response.user.notifyPrefs,
        }))
        .sort((a, b) => new Date(b.timestamp).valueOf() - new Date(a.timestamp).valueOf()),
    [row.alert.responses]
  )

  return (
    <Grid
      container={true}
      data-testid="alert-content-panel"
      sx={[
        {
          gap: 1,
        },
        classes.alertTablePanel,
      ]}
    >
      <Grid size={12}>
        <Typography variant="body1">History</Typography>
      </Grid>
      <Grid size={12}>
        <SimpleTable rows={rows} columns={columns} className="childDataGrid" sx={classes.alertTableDataGrid} />
      </Grid>
    </Grid>
  )
}

export default AlertsTablePanelContent
